<template>
    <div class="appointment">
        <handwriting v-if="canvsShow" :fromRoute="fromRoute" class="handwritings" @func="getMsgFormSon"></handwriting>
    </div>
</template>
<script>
import handwriting from '@/components/handwriting.vue'
import { setTimeout } from 'timers';
export default {
    components: {
        handwriting,
    },
    data () {
      return {
          canvsShow: false,
          fromRoute: '',
          phone: this.$route.query.phone,
          name: this.$route.query.name
      }
    },
    created(){
        const fromRoute = this.$loca.getItem('routeItem');
        this.fromRoute = fromRoute;
        if(fromRoute != '/appointment' && fromRoute != '/servicedetail' ){
            this.$router.push({path:'/'})
        }
    },
    mounted(){
        setTimeout(()=>{
            this.canvsShow = true;
        },1000)
        
    },
    methods: {
        getMsgFormSon(status){
            this.$router.push({path:'/contractStatus',query: { status, phone: this.phone  }});
        }
    }
}
</script>

<style lang="scss" scoped>
.appointment{
    position: relative;
    width: 100vw;
    height: 100%;
    .handwritings{
        height: 100%;
    }
}
</style>

